<script>
/**
 * Revenue Analytics component
 */
export default {
  props: {
    statistics: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      period: 'semana', // dia | semana | mes
    };
  },
  computed: {
    analiseReceita() {
      return this.statistics.analiseReceita || { dia: { labels: [], series: [] }, semana: { labels: [], series: [] }, mes: { labels: [], series: [] } };
    },
    receitaResumo() {
      return this.statistics.receitaResumo || {
        esteMes: { valor: 0, percentual: 0 },
        esteAno: { valor: 0, percentual: 0 },
        anoAnterior: { valor: 0 }
      };
    },
    currentChartData() {
      const data = this.analiseReceita[this.period];
      return data || { labels: [], series: [] };
    },
    series() {
      const s = this.currentChartData.series || [];
      if (s.length === 0) {
        const labels = this.currentChartData.labels || [];
        const zeros = labels.length ? labels.map(() => 0) : [0];
        return [{ name: 'Receita', type: 'column', data: zeros }];
      }
      return s;
    },
    chartOptions() {
      const labels = this.currentChartData.labels && this.currentChartData.labels.length
        ? this.currentChartData.labels
        : [''];
      return {
        chart: {
          height: 280,
          type: "line",
          toolbar: { show: false }
        },
        stroke: {
          width: [0, 3],
          curve: "smooth"
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "20%"
          }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        colors: ["#5664d2", "#1cbb8c"],
        xaxis: { categories: labels }
      };
    },
    formattedEsteMes() {
      return this.formatCurrency(this.receitaResumo.esteMes.valor);
    },
    formattedEsteAno() {
      return this.formatCurrency(this.receitaResumo.esteAno.valor);
    },
    formattedAnoAnterior() {
      return this.formatCurrency(this.receitaResumo.anoAnterior.valor);
    },
    chartKey() {
      const data = this.currentChartData;
      const hasData = (data.series && data.series.length) ? 'loaded' : 'empty';
      return `${this.period}-${hasData}-${(data.labels || []).length}`;
    },
  },
  methods: {
    formatCurrency(value) {
      if (value == null || isNaN(value)) return 'R$ 0,00';
      return 'R$ ' + Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    setPeriod(p) {
      this.period = p;
    },
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="float-right d-none d-md-inline-block">
        <div class="btn-group mb-2">
          <button type="button" class="btn btn-sm btn-light" :class="{ active: period === 'dia' }" @click="setPeriod('dia')">Dia</button>
          <button type="button" class="btn btn-sm btn-light" :class="{ active: period === 'semana' }" @click="setPeriod('semana')">Semana</button>
          <button type="button" class="btn btn-sm btn-light" :class="{ active: period === 'mes' }" @click="setPeriod('mes')">Mês</button>
        </div>
      </div>
      <h4 class="card-title mb-4">Análise de receita</h4>
      <div>
        <div id="line-column-chart" class="apex-charts" dir="ltr"></div>
        <apexchart
          :key="chartKey"
          class="apex-charts"
          height="280"
          dir="ltr"
          :series="series"
          :options="chartOptions"
        ></apexchart>
      </div>
    </div>

    <div class="card-body border-top text-center">
      <div class="row">
        <div class="col-sm-4">
          <div class="d-inline-flex">
            <h5 class="mr-2">{{ formattedEsteMes }}</h5>
            <div :class="receitaResumo.esteMes.percentual >= 0 ? 'text-success' : 'text-danger'">
              <i class="mdi font-size-14" :class="receitaResumo.esteMes.percentual >= 0 ? 'mdi-menu-up' : 'mdi-menu-down'"></i>{{ receitaResumo.esteMes.percentual }} %
            </div>
          </div>
          <p class="text-muted text-truncate mb-0">Este mês</p>
        </div>

        <div class="col-sm-4">
          <div class="mt-4 mt-sm-0">
            <p class="mb-2 text-muted text-truncate">
              <i class="mdi mdi-circle text-primary font-size-10 mr-1"></i> Este Ano :
            </p>
            <div class="d-inline-flex">
              <h5 class="mb-0 mr-2">{{ formattedEsteAno }}</h5>
              <div :class="receitaResumo.esteAno.percentual >= 0 ? 'text-success' : 'text-danger'">
                <i class="mdi font-size-14" :class="receitaResumo.esteAno.percentual >= 0 ? 'mdi-menu-up' : 'mdi-menu-down'"></i>{{ receitaResumo.esteAno.percentual }} %
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mt-4 mt-sm-0">
            <p class="mb-2 text-muted text-truncate">
              <i class="mdi mdi-circle text-success font-size-10 mr-1"></i> Ano anterior :
            </p>
            <div class="d-inline-flex">
              <h5 class="mb-0">{{ formattedAnoAnterior }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>